import { render, staticRenderFns } from "./UiEditor5.vue?vue&type=template&id=22ff39b6&scoped=true"
import script from "./UiEditor5.vue?vue&type=script&lang=js"
export * from "./UiEditor5.vue?vue&type=script&lang=js"
import style0 from "./UiEditor5.vue?vue&type=style&index=0&id=22ff39b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ff39b6",
  null
  
)

export default component.exports